import { render, staticRenderFns } from "./ServiceRequirements.vue?vue&type=template&id=30f80510"
import script from "./ServiceRequirements.vue?vue&type=script&lang=js"
export * from "./ServiceRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports